import React from 'react';
import {
	Radio,
	FormGroup,
	FormControlLabel,
	Grid,
	MenuItem,
	TextField
} from '@mui/material';
import { HelpIcon } from 'shared/components';

export default function DeliveryOptions({ form, donorDefault }) {
	const { values, setFieldValue } = form;
	const [errors, setErrors] = React.useState({});
	const [ deliveryAt, setDeliveryAt ] = React.useState([
		{ name: 'Daily', checked: false },
		{ name: 'Weekly', checked: false },
		{ name: 'Monthly', checked: false }
	]);

	React.useEffect(() => {
		if (values && values.deliveryDigestAt) {
			const newDeliveryAt = deliveryAt.map(delivery => {
				if (delivery.name === values.deliveryDigestAt) {
					delivery.checked = true;
				}
				return delivery;
			});
			setDeliveryAt(newDeliveryAt);
		}
	}, []);

	const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

	const handleChangeDelivery = (field, checked) => {
		const otherField = (field === 'deliveryImmediate') ? 'deliveryDigest' : 'deliveryImmediate';
		setFieldValue(field, checked);
		setFieldValue(otherField, false);
	};

	const handleChangeDeliveryAt = (index, checked) => {
		const newDeliveryAt = deliveryAt.map((option, idx) => {
			return {
				...option,
				checked: (idx === index) ? checked : false
			};
		});
		setDeliveryAt(newDeliveryAt);
		const deliveryAtValue = newDeliveryAt.reduce((acc, item) => {
			if (item.checked) {
				acc = item.name;
			}
			return acc;
		}, null);
		setFieldValue('deliveryDigestAt', deliveryAtValue);
	};

	const getText = (option) => {
		if (option === 'Daily') {
			return 'Pending notifications will digest every day at 9:00 am EST.';
		} else if (option === 'Weekly') {
			return 'Pending notifications will digest on the chosen day of the week at 9:00 am EST.';
		}
		return 'Pending notifications will digest on the first day of each month at 9am EST.';
	};

	return (
		<Grid container direction="row" justify="center" alignItems="center">
			<Grid item xs={12}>
				<p>Delivery options:</p>
				<FormControlLabel
					style={{marginRight: '0px'}}
					control={<Radio
						checked={values.deliveryImmediate}
						onChange={e => handleChangeDelivery('deliveryImmediate', e.target.checked)}
						color="primary"
					/>}
					label={'Immediate'}
					error={errors.deliveryOption}
				/>
				<HelpIcon text="Immediate delivery means this notification will be sent as soon as it is triggered"/>
			</Grid>
			<Grid item xs={12}>
				<FormControlLabel
					disabled={false}
					style={{marginRight: '0px'}}
					control={<Radio
						checked={values.deliveryDigest}
						onChange={e => handleChangeDelivery('deliveryDigest', e.target.checked)}
						color="primary"
					/>}
					label={'Digest'}
					error={errors.deliveryOption}
				/>
				<HelpIcon
					text={'Digest delivery means this notification will collect one or more notifications and deliver an email on the ' +
						'selected schedule containing all of the collected notifications'}
				/>
			</Grid>
			{ values.deliveryDigest && (
				<Grid item xs={12} style={{marginTop: '16px'}}>
					<FormGroup row>
						{deliveryAt.map((option, idx) => {
							return (
								<>
								<FormControlLabel
									style={{marginRight: '0px', fontSize: '1em !important', color: '#999'}}
									control={<Radio
										checked={option.checked}
										onChange={e => handleChangeDeliveryAt(idx, e.target.checked)}
										color="primary"
									/>}
									label={option.name}
									error={errors.deliveryAt}
								/>
								<HelpIcon text={getText(option.name)}/>
								</>
							);
						})}
					</FormGroup>
				</Grid>
			)}
			{ values.deliveryDigest && values.deliveryDigestAt === 'Weekly' && (
				<Grid container direction="row" justify="center" alignItems="center">
					<p>Select day of the week:</p>
					<Grid items xs={12}>
						<TextField
							select
							fullWidth
							value={values.deliveryDigestWeekday}
							onChange={(_, { props }) => setFieldValue('deliveryDigestWeekday', props.value)}
						>
							{ weekdays.map(day => (<MenuItem key={day} value={day}>{day}</MenuItem>))}
						</TextField>
					</Grid>
				</Grid>
			)}
		</Grid>
	);
}
